import Vue from 'vue'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import plugins from './plugins'
import './assets/css/style.css'
import {getRequest} from "@/api/api";
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.prototype.getRequest = getRequest;
// 图片上传组件
import ImageUpload from "@/components/ImageUpload"


Vue.component('ImageUpload', ImageUpload)

Vue.config.productionTip = false
Vue.use(Element)
Vue.use(plugins)
Vue.use(Vant);
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
